import {
  CARE_MANAGEMENT_COHORT_MODAL_STATE,
  CARE_MANAGEMENT_COHORT_MODAL_STATE_KEY,
} from 'common/constants';

export const resetCareManagementModalState = () => {
  localStorage.setItem(
    CARE_MANAGEMENT_COHORT_MODAL_STATE_KEY,
    CARE_MANAGEMENT_COHORT_MODAL_STATE.NOT_DISPLAYED,
  );
};
